<template>
	<div class="menu-item-detail-container" :class="setResponsiveClasses">
		<back-navigation v-if="$mq === 'desktop'" />
		<BaseLoader v-if="!hasItem"/>
		<adapted-component adapter-name="MenuItemDetail" path="menu" />
	</div>
</template>

<script>
import _Adapter from '@Adapter';

import itemDetailMixin from '@Mixin/itemDetailMixin';
import BackNavigation from '@Menu/BackNavigation.vue';
import { ResponsiveMixin } from "vue-responsive-components";
import EventBus from '../mixins/eventBus';

export default {
	mixins: [
		itemDetailMixin,
		ResponsiveMixin,
	],
	beforeRouteLeave(to, from, next) {
		// This is needed to support firing off the update item if you are editing
		// an item. Before this (and the listener in ItemDetailActions.vue) were added
		// you could get into a weird state when editing a bundle. Now all of your
		// edits will be saved IF and only if you are in a valid state when you leave.
		// So, if you remove 1 pizza from a 2 pizza bundle and then navigate away you will
		// still have your 2 pizzas, unedited, in your cart. If you make edits but don't
		// click the "Update" button AND you are in a valid state then your edits will be saved
		EventBus.$emit('leavingEdit');
		next();
	},
	breakpoints: {
		compactTablet: (el) => {
			return (el.width >= 768 && el.width <= 1088);
		},
		compressedView: (el) => {
			return (el.width >= 1088 && el.width <= 1400);
		},
	},
	data () {
		return {
			item: null,
		}
	},
	components : {
		'back-navigation': BackNavigation,
		'adapted-component': _Adapter,
	},
	computed: {
		setResponsiveClasses() {
			if (this.el.is.compressedView) {
				return 'detail--compressed';
			}
			if (this.el.is.compactTablet) {
				return 'detail--tablet-compact';
			}
			return '';
		},
		hasItem() {
			const $route = this.$route;
			const item = $route.params.item;
			this.item = item;
			if (!this.item) {
				this.itemId = this.$route.params.name;
				this.item = this.getItem(this.itemId);
			}
			return !!this.item;
		}
	},
}
</script>

<style lang="scss" scoped>
	@import '@style-vars';
</style>



// WEBPACK FOOTER //
// src/components/menu/MenuItemDetailRoute.vue